import { __awaiter, __generator } from "tslib";
import { fetchSearch } from './http/fetch-search';
import { SearchUrlSuffix } from './models/search-url-suffix';
export var fetchSearchRoot = function (parameters) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchSearch(SearchUrlSuffix.Root, parameters)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
